export const FLAG_GROUP_LABEL = {
    site: 'Сайт',
    clients: 'Общение с клиентами',
    b2b: 'Организации',
    work: 'Мастерская',
    money: 'Деньги и документы',
};
const defs = {
    site_catalog: {
        title: 'Каталог реек на сайте',
        description: 'Восстановленные рейки, отмеченные «Показывать на сайте», видны в каталоге и на главной.',
        default: true,
        group: 'site',
        public: true,
    },
    site_cart: {
        title: 'Корзина',
        description: 'Покупка нескольких реек за раз. Если выключено, на карточке остаётся «Купить в 1 клик».',
        default: false,
        group: 'site',
        public: true,
        requires: ['site_catalog'],
    },
    site_b2b_promo: {
        title: 'Блок «Для организаций» на главной',
        description: 'Предложение для автосервисов и автопарков. Пункты блока зависят от остальных флагов.',
        default: true,
        group: 'site',
        public: true,
    },
    delivery_regions: {
        title: 'Доставка транспортной компанией',
        description: 'На карточке товара появляется доставка по России.',
        default: false,
        group: 'site',
        public: true,
    },
    order_tracking: {
        title: 'Отслеживание заказа на сайте',
        description: 'Клиент видит статус ремонта по номеру заказа и последним цифрам телефона.',
        default: false,
        group: 'clients',
        public: true,
    },
    estimate_online: {
        title: 'Согласование сметы по ссылке',
        description: 'Клиент открывает смету с фото дефектовки и согласует её сам. Без этого — согласование по телефону.',
        default: false,
        group: 'clients',
        public: true,
    },
    sms: {
        title: 'SMS клиентам',
        description: 'Смета на согласование и «рейка готова» уходят по SMS. Нужен ключ SMS-сервиса в настройках сервера.',
        default: false,
        group: 'clients',
        public: true,
    },
    b2b_cabinet: {
        title: 'Кабинет для организаций',
        description: 'Автосервисы и автопарки входят в кабинет, сдают рейки, согласуют сметы, берут рейки из фонда.',
        default: false,
        group: 'b2b',
        public: true,
    },
    b2b_fleet: {
        title: 'Автопарк в кабинете',
        description: 'Организация ведёт список своих машин и видит историю ремонтов по каждой.',
        default: false,
        group: 'b2b',
        public: false,
        requires: ['b2b_cabinet'],
    },
    partner_prices: {
        title: 'Партнёрские цены',
        description: 'Отдельная цена на рейки из фонда для организаций.',
        default: false,
        group: 'b2b',
        public: true,
    },
    masters: {
        title: 'Мастера',
        description: 'Назначение мастера на заказ и загрузка по мастерам.',
        default: false,
        group: 'work',
        public: false,
    },
    inventory: {
        title: 'Склад запчастей',
        description: 'Остатки ремкомплектов и списание деталей на заказ.',
        default: false,
        group: 'work',
        public: false,
    },
    npd: {
        title: 'Чеки самозанятого',
        description: 'Напоминания выбить чек в «Мой налог» и учёт дохода против лимита НПД.',
        default: true,
        group: 'money',
        public: false,
    },
    documents: {
        title: 'Счета и акты',
        description: 'Счета на оплату и акты для организаций с нумерацией. Включайте после перехода на ИП или ООО.',
        default: false,
        group: 'money',
        public: true,
    },
};
export const FEATURE_FLAGS = defs;
export const FLAG_KEYS = Object.keys(defs);
export function defaultFlags() {
    return Object.fromEntries(FLAG_KEYS.map((k) => [k, FEATURE_FLAGS[k].default]));
}
export function publicFlags(flags) {
    return Object.fromEntries(FLAG_KEYS.filter((k) => FEATURE_FLAGS[k].public).map((k) => [k, flags[k]]));
}
/** Флаг включён и включены все флаги, от которых он зависит. */
export function isOn(flags, key) {
    if (!flags || !flags[key])
        return false;
    const req = FEATURE_FLAGS[key].requires;
    return req ? req.every((r) => !!flags[r]) : true;
}
//# sourceMappingURL=flags.js.map